import { useTheme } from "@mui/material";
function usePaletteMaxHeight(args) {
  const { spacing } = useTheme();
  const { swatchesPerRow, maxRowsBeforeScrolling, swatchSize, swatchesGap, palette } = args;
  const rows = Math.ceil(palette.length / swatchesPerRow);
  const gridGap = Number.parseInt(spacing(swatchesGap));
  return maxRowsBeforeScrolling > rows ? void 0 : computePaletteHeight(maxRowsBeforeScrolling, swatchSize, gridGap);
}
function computePaletteHeight(rows, chipSize, gridGap) {
  return rows * chipSize + (rows - 1) * gridGap;
}
export {
  usePaletteMaxHeight
};
//# sourceMappingURL=usePaletteMaxHeight.js.map
